import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { Plus } from "lucide-react";
import { List } from "../../../../../../../../components/shared/Form";
import { Table, TableBody, TableHead, TableHeader, TableRow } from "../../../../../../../../components/ui/table";
import Button from "../../../../../../../../components/shared/Button";
import Progress from "./Progress";
import Section from "./Section";
import { useGroups } from "../../../../../../../Settings/General/OrganisationLevelGroups/context";

function Advanced() {
    const { t } = useTranslation();
    const { allocatedGroups } = useGroups();
    const { control } = useFormContext();
    const sections = useWatch({ control, name: "sections" });

    return (
        <>
            <Progress />

            <List name="sections">
                {(fields, { add, remove }) => (
                    <>
                        <Table className="events-table tw-w-full tw-mb-4 tw-table-fixed">
                            <TableHeader className="tw-bg-neutral-100">
                                <TableRow>
                                    <TableHead className="tw-text-neutral-700 tw-border-t-0 tw-w-40">
                                        {t("start")}
                                    </TableHead>
                                    <TableHead className="tw-text-neutral-700 tw-border-t-0 tw-w-40">
                                        {t("end")}
                                    </TableHead>
                                    <TableHead className="tw-text-neutral-700 tw-border-t-0 tw-w-44">
                                        {t("time-code")}
                                    </TableHead>
                                    <TableHead className="tw-text-neutral-700 tw-border-t-0 tw-w-40">
                                        {t("duration")}
                                    </TableHead>
                                    {allocatedGroups?.map((group: any) => (
                                        <TableHead key={group.id} className="tw-text-neutral-700 tw-border-t-0 tw-w-44">
                                            {group.description}
                                        </TableHead>
                                    ))}
                                    <TableHead className="tw-w-20" />
                                </TableRow>
                            </TableHeader>
                            <TableBody key="sections-table">
                                {fields.map((field, index) => (
                                    <Section
                                        key={field.id}
                                        index={index}
                                        remove={() => remove(index)}
                                        isFirstSection={index === 0}
                                        isLastSection={index === fields.length - 1}
                                    />
                                ))}
                            </TableBody>
                        </Table>

                        <div className="tw-w-full tw-flex tw-justify-end">
                            <Button
                                type="button"
                                variant="ghost"
                                onClick={() => {
                                    const lastSection: any = sections?.[sections.length - 1];
                                    add({
                                        ...lastSection,
                                        start: lastSection?.end,
                                        end: undefined,
                                        duration: "",
                                    });
                                }}
                            >
                                <Plus /> {t("add")}
                            </Button>
                        </div>
                    </>
                )}
            </List>
        </>
    );
}

export default Advanced;
